// extracted by mini-css-extract-plugin
export default {"ball":"DotBall_ball__CWcIC","confirm":"DotBall_confirm__4EpYL","pending":"DotBall_pending__8lCBA","cancelled":"DotBall_cancelled__FuQnS","completed":"DotBall_completed__cKofu"};